module.exports = __webpack_public_path__ + "img/monnezza-left-top.ee9378da.png";